import { mergeDeep } from "game_play/utils"
import NodeHandler from "../../../node_handler"

class ScrollSpySidebarTarget extends NodeHandler{
    __init_dom_schema(){
        return {
            wrapper: '.js-sticky-sidebar__wrapper',
            inner: '.js-sticky-sidebar__inner',
        }
    }
    __init(){
        this.node.addEventListener('wheel', this.onWheelSelf.bind(this))
        this.args.offset = mergeDeep({
                top: () => 0
        }, this.args?.offset ?? {})
        console.log(this)

        this.current_y = 0
        // this.is_fixed = false
        this.is_fixed_top = false
        this.is_fixed_bottom = false

        this.dom.inner.style.transition = '0.2s'
        // this.node.style.position = 'relative'
        this.dom.wrapper.style.position = 'sticky'
        this.dom.wrapper.style.overflow = 'hidden'
        // this.node.style.overflow = 'hidden'

        this.deltaY = 0
    }
    onWheelSelf(event){
        event.preventDefault()
        event.stopPropagation()

        this.deltaY = event.deltaY
        // console.log(event, event.deltaY)

        // const rect_wrapper = this.dom.wrapper.getBoundingClientRect()
        // const rect = this.node.getBoundingClientRect()
        // const rect_inner = this.dom.inner.getBoundingClientRect()

        // const offset_top = this.args.offset.top()

        // const t = rect_inner.height - (this.current_y + event.deltaY)
        // // const u = window.innerHeight - rect_inner.top
        // const u = window.innerHeight - rect_wrapper.top
        // // const u = window.innerHeight - (rect.height) - rect_wrapper.top

        // if( t < u ){
        //     this.current_y = rect_inner.height - window.innerHeight + rect_wrapper.top
        // }else if ((this.current_y + event.deltaY) < 0){
        //     this.current_y = 0
        // }
        // else{
        //     this.current_y += event.deltaY
        // }

        // if(rect_inner.top + event.deltaY > window.innerHeight + offset_top){

        // }
        // window.innerHeight

        // console.log(
        //     't', t,
        //     'u', u,
        //     'rect_wrapper.top', rect_wrapper.top, 
        //     'rect_wrapper.bottom', rect_wrapper.bottom,
        //     'rect.bottom', rect.bottom,
        //     'rect_inner.top', rect_inner.top, 
        //     'rect_inner.height', rect_inner.height, 
        //     'this.current_y', this.current_y, 
        //     'window.scrollY', window.scrollY,
        //     'window.innerHeight', window.innerHeight,
        //     'event.deltaY', event.deltaY,
        //     rect,
        // )

        this.recount()
    }
    onScroll(event){
        this.recount()
    }
    onResize(event){
        this.recount()
    }
    recount(){
        const rect_wrapper = this.dom.wrapper.getBoundingClientRect()
        const rect = this.node.getBoundingClientRect()
        const rect_inner = this.dom.inner.getBoundingClientRect()
        const offset_top = this.args.offset.top()

        let top_offset = 0
        let view_height = window.innerHeight - rect_wrapper.top

        // if(rect.heightrect_inner.height){

        // }
        if(view_height > rect_inner.height){
            this.current_y = 0
        }
        else{
            if(rect_wrapper.top < 0){
                view_height = rect_wrapper.height + rect_wrapper.top
                top_offset = rect_wrapper.top - offset_top
            }
            // console.log('view_height',view_height, rect_inner.height)
            const y_appended = this.current_y + this.deltaY
            if( rect_inner.height - y_appended < view_height && rect_wrapper.top > 0){
                this.current_y = rect_inner.height - window.innerHeight + rect_wrapper.top - top_offset
            }else if (rect_inner.height - y_appended + top_offset < view_height && rect_wrapper.top < 0){
                this.current_y = 0
            }else if (y_appended < top_offset){
                this.current_y = top_offset
            }
            else{
                this.current_y += this.deltaY
            }
        }
        
        this.deltaY = 0
        this.dom.wrapper.style.top = this.args.offset.top() + 'px'
        this.dom.inner.style.transform = `translate(0, ${(-this.current_y)}px)`
    }
}

export {
    ScrollSpySidebarTarget
}